import { t, Trans, Plural } from '@lingui/macro';
import React from 'react';

import { CommonFaceResponse } from '@api/v4/private/people_tagging/faces';
import { BFLoader } from '@components/common/loader/main';
import { PrimaryButton, TertiaryButton } from '@components/library/button/index';

interface BulkPeopleContentProps {
  assetCount: number;
  handleClose: () => void;
  handleRemoveFace: (faceIds: string[]) => void;
  handleSave: () => void | Promise<void>;
  isLoadingFaces: boolean;
  isSubmitting: boolean;
  removedFaceIdsCount: number;
  visibleFaces: CommonFaceResponse[];
}

const BulkPeopleContent: React.FC<BulkPeopleContentProps> = ({
  assetCount,
  handleClose,
  handleRemoveFace,
  handleSave,
  isLoadingFaces,
  isSubmitting,
  removedFaceIdsCount,
  visibleFaces,
}) => (
  <div className="modal-content-wrapper bulk-people-modal">
    <div className="modal-content-wrapper__body">
      {isLoadingFaces ? (
        <BFLoader />
      ) : visibleFaces.length === 0 ? (
        <p className="no-common-faces">
          <Trans>No common faces found for the selected assets.</Trans>
        </p>
      ) : (
        <>
          <h3 className="body-title">
            <Plural
              one={
                <Trans>
                  Remove people tags from <strong>common</strong> faces for <strong>{assetCount} asset</strong>
                </Trans>
              }
              other={
                <Trans>
                  Remove people tags from <strong>common</strong> faces for <strong>{assetCount} assets</strong>
                </Trans>
              }
              value={assetCount}
            />
          </h3>
          <div className="people-grid">
            {visibleFaces.map((face) => (
              <div key={face.face_ids[0]} className="person-entry">
                <div className="person-image-container">
                  <img
                    alt={face.identity_name}
                    className="person-image"
                    src={face.identity_thumbnail_url}
                  />
                  <button
                    aria-label={t`Remove ${face.identity_name}`}
                    className="remove-person-button"
                    onClick={() => handleRemoveFace(face.face_ids)}
                    type="button"
                  >
                    <span aria-hidden="true" className="bff-close" />
                  </button>
                </div>
                <p className="person-name">{face.identity_name}</p>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
    <div className="button-container">
      <TertiaryButton
        className="t-close-modal"
        disabled={isSubmitting || isLoadingFaces}
        onClick={handleClose}
        size="small"
      >
        <Trans>Close</Trans>
      </TertiaryButton>
      <PrimaryButton
        className="t-confirm-modal"
        disabled={removedFaceIdsCount === 0 || isLoadingFaces}
        isLoading={isSubmitting}
        onClick={() => void handleSave()}
        size="small"
      >
        <Trans>Save</Trans>
      </PrimaryButton>
    </div>
  </div>
);

export default BulkPeopleContent;
